// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"84485e16","453":"142a8c69","719":"fb8dd9c3"}[chunkId] + ".chunk.js";
};